import cn from 'classnames';
import { FC } from 'react';
import { Link } from 'react-router';

import { BreadcrumbElementType } from '@/shared/config';

import { Icon } from '../Icon/Icon';

import styles from './Breadcrumbs.module.scss';

type MobileBreadcrumbItemProps = {
  breadcrumb: BreadcrumbElementType;
  isClickable?: boolean;
  isLast?: boolean;
};

export const MobileBreadcrumbItem: FC<MobileBreadcrumbItemProps> = (props) => {
  const { breadcrumb, isClickable = true, isLast = false } = props;

  if (!breadcrumb.path || !isClickable) {
    return (
      <>
        {!isLast && (
          <Icon
            name="arrowDown"
            className={cn(styles.arrow, styles.mobileArrow)}
            size={32}
          />
        )}

        <p className={cn(styles.labelContainer, 'h4')}>{breadcrumb.label}</p>
      </>
    );
  }

  return (
    <>
      <Link
        to={breadcrumb.path}
        state={breadcrumb.state}
        className={styles.mobileLink}
      >
        <Icon
          name="arrowDown"
          className={cn(styles.arrow, styles.mobileArrow)}
          size={32}
        />
      </Link>

      <p className={cn(styles.labelContainer, 'h4')}>{breadcrumb.label}</p>
    </>
  );
};
